export default __webpack_public_path__ + "static/media/1771.0d831566.png";